const PRE_OPERATIONAL_REAL_INCIDENT_STATUSES = new Set(['', 'open']);

const normalizeStatus = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, '_');
const normalizeId = (value) => String(value || '').trim();
const normalizeIds = (value) => (Array.isArray(value) ? value : [])
  .filter(Boolean)
  .map((entry) => String(entry))
  .sort();
const displayValue = (value) => String(value || '').trim() || '—';

export const realIncidentCorrectionLockReason = (incident = {}) => {
  if (!incident || incident.is_exercise || incident.is_scenario || incident.is_planned_event) return '';
  if (incident.operational_started_at) return 'Incident operations have already started.';
  if (String(incident.plan_state || '').trim().toLowerCase() === 'active' || incident.plan_activated_at) {
    return 'The response plan has already been activated.';
  }
  const status = normalizeStatus(incident.status);
  if (!PRE_OPERATIONAL_REAL_INCIDENT_STATUSES.has(status)) {
    return status === 'in_progress'
      ? 'The incident is already In Progress.'
      : 'The incident is no longer in its pre-operational stage.';
  }
  return '';
};
export const canCorrectRealIncidentReport = (incident, isAdmin) => Boolean(
  isAdmin
  && incident
  && !incident.is_exercise
  && !incident.is_scenario
  && !incident.is_planned_event
  && !realIncidentCorrectionLockReason(incident)
);

export const buildIncidentDefinitionChanges = (incident = {}, payload = {}) => {
  if (!payload) return [];
  const changes = [];
  const addScalar = (field, label, oldRaw, newRaw, oldDisplay, newDisplay) => {
    if (normalizeId(oldRaw) === normalizeId(newRaw)) return;
    changes.push({
      field,
      label,
      oldValue: displayValue(oldDisplay ?? oldRaw),
      newValue: displayValue(newDisplay ?? newRaw),
    });
  };

  addScalar('type_id', 'Incident Type', incident.type_id, payload.type_id, incident.incident_type, payload.incident_type);
  addScalar('event_id', 'Event', incident.event_id, payload.event_id, incident.event, payload.event);
  addScalar('trigger_id', 'Trigger', incident.trigger_id, payload.trigger_id, incident.trigger, payload.trigger);
  addScalar('severity', 'Severity', incident.severity, payload.severity, incident.severity, payload.severity);

  const oldLocationIds = normalizeIds(incident.location);
  const newLocationIds = normalizeIds(payload.location);
  const oldUnknown = Boolean(incident.is_unknown_location);
  const newUnknown = Boolean(payload.is_unknown_location);
  if (
    JSON.stringify(oldLocationIds) !== JSON.stringify(newLocationIds)
    || oldUnknown !== newUnknown
  ) {
    const oldNames = Array.isArray(incident.location_names) ? incident.location_names.filter(Boolean).join(' > ') : '';
    const newNames = Array.isArray(payload.location_names) ? payload.location_names.filter(Boolean).join(' > ') : '';
    changes.push({
      field: 'location',
      label: 'Incident Location',
      oldValue: oldUnknown ? 'Unknown Location' : displayValue(oldNames || oldLocationIds.join(' > ')),
      newValue: newUnknown ? 'Unknown Location' : displayValue(newNames || newLocationIds.join(' > ')),
    });
  }

  return changes;
};
